import {
  createParamContext,
  makeStringParser,
} from 'app/components/router/createParamContext';

export const RETURN_FROM_SCREEN_SHARING_TO_QUERY_PARAM = 'returnFromScreenSharingTo';

export const {
  Provider: ReturnFromScreenSharingQueryProvider,
  useParams: useReturnFromScreenSharing,
} = createParamContext(
  makeStringParser(RETURN_FROM_SCREEN_SHARING_TO_QUERY_PARAM),
);
